import React from 'react';
import PropTypes from 'prop-types';
import AppBackButton from 'components/AppBackButton';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding:  0 15px 0 15px;
`;

const BackButton = ({ route }) => (
  <Wrapper>
    <AppBackButton
      type="manualGrade"
      icon="back"
      route={route}
    />
  </Wrapper>
);

BackButton.propTypes = {
  route: PropTypes.string,
};

export default BackButton;
